import React from 'react';
import './featureContent.css';

/**
 * Numbered step cards.
 * @param {{title: string, description: string}[]} steps
 */
function FeatureSteps({ steps }) {
    return (
        <div className="fc-steps">
            {steps.map((step, index) => (
                <div className="fc-step-card" key={step.title}>
                    <div className="fc-step-number">{index + 1}</div>
                    <h3 className="fc-step-title">{step.title}</h3>
                    <p className="fc-step-description">{step.description}</p>
                </div>
            ))}
        </div>
    );
}

export default FeatureSteps;
